/**
 * Client-side API access for the admin SPA. The API lives on its own host
 * (api.<domain>) — admin must call it directly (no same-origin /api proxy).
 * Base derived from the current hostname so one build works everywhere.
 */
export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (typeof window === "undefined") return p;
  const h = window.location.hostname;
  // Dev: hit the local worker directly (no Next rewrite for the Vite admin SPA);
  // the dev worker mounts under /api, so keep the prefix.
  if (h === "localhost" || h === "127.0.0.1") return `http://localhost:8788${p}`;
  // Prod/staging: dedicated API host, routes at root → drop the /api prefix.
  const base =
    h === "staging.podecontratar.com.br" || h.endsWith(".staging.podecontratar.com.br")
      ? "https://api.staging.podecontratar.com.br"
      : "https://api.podecontratar.com.br";
  return `${base}${p.replace(/^\/api(?=\/|$)/, "") || "/"}`;
}
export function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  return fetch(apiUrl(path), { credentials: "include", ...init });
}
